module.exports = __webpack_public_path__ + "img/caranec.4b79df8c.png";